<template>
    <router-view/>
</template>

<script>
import '@/assets/css/modules/_merchant-dashboard.scss';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Merchant',
  computed: {
    ...mapGetters({
      merchantHasWhatsapp: 'merchant/merchantHasWhatsapp',
    }),
  },
  watch: {
    // call again the method if the route changes
    // eslint-disable-next-line
    '$route.params.merchant_id': function(newMerchantId, oldMerchantId) {
      this.$store.commit('resetMerchant');
      this.fetchMerchant(newMerchantId);
      this.listenForNewMessages(newMerchantId);
      // this.turnOffMerchantEventListener(oldMerchantId);
    },
  },
  mounted() {
    this.fetchPermissionRoles(this.$route.params.merchant_id);
    this.fetchMerchant(this.$route.params.merchant_id);
    this.listenForNewMessages(this.$route.params.merchant_id);
    // this.listenForMerchantActivity(this.$route.params.merchant_id);
  },
  beforeDestroy() {
    this.$store.commit('resetMerchant');
  },
  methods: {
    ...mapActions({
      fetchMerchant: 'merchant/fetchMerchant',
      fetchPermissionRoles: 'merchant/fetchPermissionRoles',
      fetchStatistics: 'chat/fetchStatistics',
      listenForNewMessages: 'pusher/listenForNewMessages',
      // turnOffMerchantEventListener: 'pusher/turnOffMerchantEventListener',
      // listenForMerchantActivity: 'pusher/listenForMerchantActivity',
    }),
  },
};
</script>
